export default __webpack_public_path__ + "static/media/Bonito22SwagNewsletter.f20a7d04.xml";